import { UserMenuWidgetElement } from './define-user-menu-element';

export function registerUserMenuWidget() {
  if (typeof window === 'undefined') return;
  if (window.customElements.get('adipa-user-menu')) return;

  window.customElements.define('adipa-user-menu', UserMenuWidgetElement);
}
